import React, { useMemo } from 'react'
import { observer } from 'mobx-react-lite'

import { Box } from '@material-ui/core'

import { WbFilesTab } from '../../WbFilesTab'
import { WildberriesLabelsPrint } from './WildberriesLabelsPrint'
import { RouteTabSwitchItems, RoutingTabsSwitch } from '../../RoutingTabsSwitch'

import { useWbAccount } from '../../../hooks/routeHooks'

import { appRoutes, IntegrationRouteParams } from '../../../common/appRoutes'

export const WildberriesPrintPage =
  observer(() => {
    const account = useWbAccount()

    const routes =
      useMemo(() => {
          const params: IntegrationRouteParams = {
            integration: 'Wildberries',
            accountId: account.id
          }

          return [{
            title: 'Этикетки',
            template: appRoutes.Store.print.labels.template,
            path: appRoutes.Store.print.labels.makeUrl(params),
            render: () => <WildberriesLabelsPrint/>
          }, {
            title: 'Файлы',
            template: appRoutes.Store.print.files.template,
            path: appRoutes.Store.print.files.makeUrl(params),
            render: () => <WbFilesTab/>
          }] as const satisfies RouteTabSwitchItems
        },
        [account])

    if (!account.isDeliveryFromSellerWarehouse) {
      return (
        <Box padding={3}>
          Печать этикеток недоступна при выбранной схеме работы.
        </Box>
      )
    }

    return <RoutingTabsSwitch routeTabs={routes}/>
  })